"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Table = void 0;
const tslib_1 = require("tslib");
const components_1 = require("@bluebase/components");
const Table_1 = tslib_1.__importDefault(require("@material-ui/core/Table"));
const react_1 = tslib_1.__importDefault(require("react"));
const Table = (props) => {
    const { style, children } = props, rest = tslib_1.__rest(props, ["style", "children"]);
    return (react_1.default.createElement(Table_1.default, Object.assign({ style: style }, rest), children));
};
exports.Table = Table;
Table.defaultProps = components_1.TableDefaultProps;
